import { RouteConfig } from 'packages/route'
import { lazy } from 'react'

export const getRoutes: () => RouteConfig[] = () => [
  {
    path: 'admin/admissions',
    name: 'AdminAdmissions',
    getTitle: () => '招生招聘',
    component: lazy(() =>
      import('./pages/List').then((m) => ({
        default: m.Admissions,
      }))
    ),
    subRoutes: [
      {
        path: 'biosource',
        getTitle: () => '生源池',
        component: lazy(() =>
          import('./pages/biosourcePool/List').then((m) => ({
            default: m.List,
          }))
        ),
      },
      {
        path: 'talent',
        getTitle: () => '人才池',
        component: lazy(() =>
          import('./pages/talentPool/TalentList').then((m) => ({
            default: m.TalentList,
          }))
        ),
      },
    ],
  },
  {
    path: 'admin/admissions/biosource/details/:id',
    name: 'AdminBiosourceDetails',
    getTitle: () => '学生详情',
    component: lazy(() =>
      import('./pages/stuDetail').then((m) => ({
        default: m.Detail,
      }))
    ),
  },
  {
    path: 'admin/admissions/talent/details/:id',
    name: 'AdminTalentDetail',
    getTitle: () => '教师详情',
    component: lazy(() =>
      import('./pages/talentPool/TalentDetail').then((m) => ({
        default: m.TalentDetail,
      }))
    ),
  },
  {
    path: 'admin/admissions/biosource/stuResource-fields-management',
    name: 'StuResourceFieldsManagement',
    getTitle: () => '字段设置',
    component: lazy(() =>
      import('./pages/StuResourceFieldManagement').then((m) => ({
        default: m.StuResourceFieldManagement,
      }))
    ),
  },
  {
    path: 'admin/admissions/talent/teacher-fields-management',
    name: 'FieldSetting',
    getTitle: () => '字段设置',
    component: lazy(() =>
      import('./pages/talentPool/FieldSetting').then((m) => ({
        default: m.FieldSetting,
      }))
    ),
  },
]
